// @flow
import React from 'react';
import { get, isNil } from 'lodash';
import { connect } from 'react-redux';
import { Pricing as PricingView } from '@views';
import type { PlanType, UserAvailablePlans } from '@types';
import { openWebBilling, checkWebCheckout, getSubscriptionTrack, getAvailablePlans, getSubscriptionUserInfo } from '@context/subscription';
import { replace } from 'connected-react-router';
import { router } from '@router';
import { logout } from '@context/user';
import { isStoreReview } from '../redux/modules/appVersion';


type Props = {
  dispatch: Function,
  availablePlans: UserAvailablePlans;
  availablePlansLoading: boolean,
  openingWebBilling: ?Object,
  webCheckout: ?Object,
  isCheckingWebCheckout: boolean,
  webCheckoutUnconfirmed: boolean,
  subscriptionStatus: ?string,
  trialEndsInDays: ?number,
  storeReview: boolean,
};

class Pricing extends React.Component<Props> {
  componentWillMount() {
    // An old "Assinar" link (e-mail, Intercom) opened by an account that is already paying. In place of
    // the plans, so Back doesn't come here again.
    if (this.props.subscriptionStatus === 'active') {
      this.props.dispatch(replace(router.getRoutePath('subscriptionInfo')));
      return;
    }
    // In review the page shows no plans, and the "Viewed-Pricing" event could start an Intercom campaign
    if (this.props.storeReview) return;
    this.props.dispatch(getSubscriptionTrack('pricing'));
    this.props.dispatch(getSubscriptionUserInfo());
    this.props.dispatch(getAvailablePlans());
  }
  render() {
    const { openingWebBilling, webCheckout } = this.props;

    return (
      <PricingView
        onSelectPlan={this.handleSelectPlan}
        availablePlans={this.props.availablePlans}
        availablePlansLoading={this.props.availablePlansLoading}
        isOpeningCheckout={!!openingWebBilling}
        openingPlan={get(openingWebBilling, 'plan', null)}
        webCheckout={get(webCheckout, 'destination') === 'subscribe' ? webCheckout : null}
        isCheckingSubscription={this.props.isCheckingWebCheckout}
        subscriptionUnconfirmed={this.props.webCheckoutUnconfirmed}
        onCheckSubscription={this.handleCheckSubscription}
        subscriptionStatus={this.props.subscriptionStatus}
        trialEndsInDays={this.props.trialEndsInDays}
        storeReview={this.props.storeReview}
        onLogout={this.handleLogout}
      />
    );
  }

  handleSelectPlan = (plan: PlanType) => {
    this.props.dispatch(openWebBilling('subscribe', plan));
  };

  handleLogout = () => this.props.dispatch(logout());

  handleCheckSubscription = () => {
    this.props.dispatch(checkWebCheckout({ userAction: true }));
  };
}


// What the server said when this page opened (subscription/track), else what the header's trial badge shows
const trialStatus = (state) => {
  const tracked = get(state, ['context', 'subscription', 'trackInfo', 'pricing']);
  const account = get(state, ['context', 'user', 'advancedData']);
  return isNil(get(tracked, 'subscriptionStatus'))
    ? { subscriptionStatus: get(account, 'subscriptionStatus'), trialEndsInDays: get(account, 'trialEndsInDays') }
    : { subscriptionStatus: get(tracked, 'subscriptionStatus'), trialEndsInDays: get(tracked, 'trialEndsInDays') };
};

const mapStateToProps = (state) => ({
  availablePlans: get(state, ['context', 'subscription', 'availablePlans']),
  availablePlansLoading: get(state, ['context', 'subscription', 'availablePlansLoading']),
  openingWebBilling: get(state, ['context', 'subscription', 'openingWebBilling'], null),
  webCheckout: get(state, ['context', 'subscription', 'webCheckout'], null),
  isCheckingWebCheckout: get(state, ['context', 'subscription', 'isCheckingWebCheckout'], false),
  webCheckoutUnconfirmed: get(state, ['context', 'subscription', 'webCheckoutUnconfirmed'], false),
  ...trialStatus(state),
  storeReview: isStoreReview(state),
});

export default connect<any, any, any, any, any, any>(
  mapStateToProps,
)(Pricing);
